import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'h3-disable-with-tooltip-helper',
  templateUrl: './disable-with-tooltip-helper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DisableWithTooltipHelperComponent implements OnChanges {
  @Input() disable?: boolean | string;
  tooltipText = '';

  ngOnChanges() {
    if (typeof this.disable === 'string') {
      this.tooltipText = this.disable;
    } else {
      this.tooltipText = '';
    }
  }
}
